document.addEventListener('DOMContentLoaded', function () {
  function setBubbleBlockDisplay() {
    const navItems = document.querySelectorAll('.bubble-block__nav-item');
    const infoItems = document.querySelectorAll('.bubble-block__info');

    navItems.forEach((navItem) => {
      navItem.addEventListener('click', function () {
        const index = navItem.getAttribute('data-index');

        infoItems.forEach((infoItem) => {
          infoItem.classList.toggle(
            'visible',
            infoItem.getAttribute('data-index') === index
          );
        });
      });
    });
  }

  if (window.innerWidth > 1199) {
    setBubbleBlockDisplay();
  }

  window.addEventListener('resize', function () {
    if (window.innerWidth > 1199) {
      setBubbleBlockDisplay();
    }
  });
});
